export const ideaSavingArticle = {
  title: 'Business Idea Generator: Saving & Next Steps',
  slug: 'idea-generator-saving',
  content: `Business Idea Generator: Saving & Next Steps

Save ideas so you can refine them and build plans.

1) Save an idea
- After generation, save the ideas you want to keep.
- Saved ideas appear in your idea list.

2) Move to business plan
- Use a saved idea to start a Business Plan.
- The Business Plan module can load saved ideas automatically.

3) Trial limits
- If the free daily limit is reached, you will see a trial offer.
`,
};
